export const handleExpirationChange = (value) => {
  setExpirationString(value);
  const splitedValue = value.split("/");
  const month = splitedValue[0] | "";
  const year = `20${splitedValue[1]}` | "";
  year && setValue("card_exp_year", year, { shouldValidate: submitCount > 0 && true, shouldTouch: true });
  month && setValue("card_exp_month", month, { shouldValidate: submitCount > 0 && true, shouldTouch: true });
};

export const formatTextWithBreak = (text, limit = 11) => {
  if (text?.length <= limit) return text;

  const breakIndex = text?.lastIndexOf(" ", limit);
  if (breakIndex !== -1) {
    return (
      <>
        {text?.slice(0, breakIndex)}
        <br />
        {text?.slice(breakIndex + 1)}
      </>
    );
  }

  return (
    <>
      {text?.slice(0, limit)}
      <br />
      {text?.slice(limit)}
    </>
  );
};

export const formatDisplayName = (displayName) => {
  const plusIndex = displayName.indexOf("+");

  if (plusIndex !== -1) {
    const name = displayName.slice(0, plusIndex).trim();
    const label = displayName.slice(plusIndex).trim();

    return (
      <>
        {name}
        <br />
        <span className="productPacItem__label__shippingLabel">{label}</span>
      </>
    );
  }

  return <>{displayName}</>;
};

export const htmlToText = (string) => {
  if (!string) return "";
  const el = document.createElement("div");
  el.innerHTML = string || "";
  return (el.textContent || "").trim();
};
